module.exports = __webpack_public_path__ + "themes/non-default/addeparStep2InvestmentName.306fe807925c772a7c34143d5e41abd5.png";